import * as z from 'zod';

export const heardAboutOptions = ['Google', 'Social Media', 'Intrepid', 'Seat 61', 'Other'] as const;

export const conciergeFormBase = z
  .object({
    whyGetIntouch: z.enum(["I'd like a custom trip", 'I have accessibility requirements', 'Any other reason']),
    whereToGo: z.string().min(1),
    whenTravelling: z.string().min(1),
    travelDuration: z.string().min(1),
    budget: z.string().min(1),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    email: z.string().email(),
    preferredContactMethod: z.string().min(1),
    leadPassengerCountry: z.string().min(1),
    elderlyPassenger: z.string().min(1),
    rooms: z.coerce.number({}).int().min(1),
    adultCount: z.coerce.number({}).int().min(1).default(2),
    childCount: z.coerce.number({}).int().min(0),
    childAges: z.string().optional(),
    numberOfElderlyPassengers: z.coerce.number({}).int().min(0),

    anythingElse: z.string().optional(),
    bestStation: z.string().optional(),
    extraPlaces: z.string().optional(),
    flexibility: z.string().optional(),
    phone: z.string().optional(),
    howDidYouHearAboutUsDetail: z.string().optional(),
    // howDidYouHearAboutUs: z.array(z.enum(heardAboutOptions)).optional(),
    howDidYouHearAboutUs: z.string().optional(),
    newsletterSignup: z.boolean().optional(),
    marketingOptOut: z.boolean().optional(),
    locale: z.string().optional(), // Hidden, auto-populated metadata (not customer-facing)
    currency: z.string().optional(), // Hidden, auto-populated metadata (not customer-facing)

    // Campaign attribution metadata (FE-forward-only; must be declared because the schema is .strict()).
    utm_source: z.string().optional(),
    term: z.string().optional(),
    utm_campaign: z.string().optional(),
    campaignid: z.string().optional(),
    gclid: z.string().optional(),
    tripType: z.string().optional(),
    medium: z.string().optional(),

    captcha: z.string(),
    // Honeypot field (should be empty)
    middleName: z.string().optional()
  })

  .strict();

export const conciergeFormSchema = conciergeFormBase.superRefine((data, ctx) => {
  if (data.preferredContactMethod === 'phone') {
    const phone = (data.phone ?? '').trim();
    if (!phone) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['phone'] });
    }
  }
});

export const submitConciergeSchema = conciergeFormBase
  .omit({ captcha: true, middleName: true })
  .superRefine((data, ctx) => {
    if (data.preferredContactMethod === 'phone') {
      const phone = (data.phone ?? '').trim();
      if (!phone) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['phone'],
          message: 'Please enter your phone number.'
        });
      }
    }
  });

export type ConciergeFormSchema = z.infer<typeof conciergeFormSchema>;
export type ConciergeSubmitPayload = z.infer<typeof submitConciergeSchema>;
